import React, { memo } from 'react';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { Block } from '../../components/core';
import { OptionsPerformanceSummaryHeader } from './options-performance-summary-header';
import { OptionsPerformanceSummaryContent } from './options-performance-summary-content';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';

type OptionsPerformanceSummaryBlockProps = Readonly<{
  id: string;
}>;

export const OptionsPerformanceSummaryBlock = memo(function InternalOptionsPerformanceSummaryBlock({
  id,
}: OptionsPerformanceSummaryBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <OptionsPerformanceSummaryHeader id={id} />
      </Block.Header>

      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS, MetricsErrorWrapper]}>
        <OptionsPerformanceSummaryContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
